export interface Category {
    name: string;
    label: string;
}

export interface SortOption {
    key: string;
    label: string;
}

export enum AppState {
    Loading,
    Error,
    Success
}

export interface CategoryCountResponse {
    [category: string]: number;
}

export interface SearchQuery {
    query: string;
    category?: string;
    ocr?: boolean;
    page?: number,
    limit?: number,
    date_one?: number,
    date_two?: number,
    sort?: string,
    exact_match?: boolean;
    terms?: {
        [term: string]: string[] | null
    }
}

export interface DetailQuery extends SearchQuery {
    index: number;
}

export interface TermsQuery {
    category: string;
}

export interface TermValuesQuery {
    query?: string;
    existing_terms?: {
        [term: string]: string[] | null
    }
    category:string;
    term: string;
    label: string;
    date_one?: number;
    date_two?: number;
    enable_ocr?: boolean;
    exact_match?: boolean;
}

export interface TermValuesResponse {
    term: string;
    label: string;
    values: {
        name: string;
        count: number;
    }[]
}

export interface SearchResult {
    id: number;
    title: string;
    tags?: string; // comma separated list of tags
    url?: string;
    category: string;
    categoryName: string;
    description?: string;
    thumbnail: null | {
        png: string;
        webp: string;
    }
}

export interface SearchResponse {
    totalHits: number;
    totalPages: number;
    data: SearchResult[];
}


export interface DetailResponse {
    thumbnail: null | {
        png: string;
        webp: string;
    };
    bestand: string;
    data: {
        id: number;
        [key: string]: string | string[] | null | number;
    }
}

export interface MeResponse {
    id: number|string,
    name: string,
    email: string
    has_premium: boolean
}
